/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AuthnContextUpdateChallengeOptions } from './AuthnContextUpdateChallengeOptions';
import {
    AuthnContextUpdateChallengeOptionsFromJSON,
    AuthnContextUpdateChallengeOptionsFromJSONTyped,
    AuthnContextUpdateChallengeOptionsToJSON,
    AuthnContextUpdateChallengeOptionsToJSONTyped,
} from './AuthnContextUpdateChallengeOptions';
import type { FactorMethod } from './FactorMethod';
import {
    FactorMethodFromJSON,
    FactorMethodFromJSONTyped,
    FactorMethodToJSON,
    FactorMethodToJSONTyped,
} from './FactorMethod';
import type { ChallengeType } from './ChallengeType';
import {
    ChallengeTypeFromJSON,
    ChallengeTypeFromJSONTyped,
    ChallengeTypeToJSON,
    ChallengeTypeToJSONTyped,
} from './ChallengeType';

/**
 * 
 * @export
 * @interface AuthnContextUpdateChallenge
 */
export interface AuthnContextUpdateChallenge {
    /**
     * 
     * @type {string}
     * @memberof AuthnContextUpdateChallenge
     */
    id: string;
    /**
     * 
     * @type {ChallengeType}
     * @memberof AuthnContextUpdateChallenge
     */
    type: ChallengeType;
    /**
     * 
     * @type {FactorMethod}
     * @memberof AuthnContextUpdateChallenge
     */
    authentication_method: FactorMethod;
    /**
     * 
     * @type {AuthnContextUpdateChallengeOptions}
     * @memberof AuthnContextUpdateChallenge
     */
    options: AuthnContextUpdateChallengeOptions;
}



/**
 * Check if a given object implements the AuthnContextUpdateChallenge interface.
 */
export function instanceOfAuthnContextUpdateChallenge(value: object): value is AuthnContextUpdateChallenge {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('authentication_method' in value) || value['authentication_method'] === undefined) return false;
    if (!('options' in value) || value['options'] === undefined) return false;
    return true;
}

export function AuthnContextUpdateChallengeFromJSON(json: any): AuthnContextUpdateChallenge {
    return AuthnContextUpdateChallengeFromJSONTyped(json, false);
}

export function AuthnContextUpdateChallengeFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuthnContextUpdateChallenge {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'type': ChallengeTypeFromJSON(json['type']),
        'authentication_method': FactorMethodFromJSON(json['authentication_method']),
        'options': AuthnContextUpdateChallengeOptionsFromJSON(json['options']),
    };
}

export function AuthnContextUpdateChallengeToJSON(json: any): AuthnContextUpdateChallenge {
    return AuthnContextUpdateChallengeToJSONTyped(json, false);
}

export function AuthnContextUpdateChallengeToJSONTyped(value?: AuthnContextUpdateChallenge | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'type': ChallengeTypeToJSON(value['type']),
        'authentication_method': FactorMethodToJSON(value['authentication_method']),
        'options': AuthnContextUpdateChallengeOptionsToJSON(value['options']),
    };
}

